// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTypography-root.productHeading {
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 20px;
    color: #EBEBF5;
    padding-left: 3px;
    padding-top: 0px;
    height: 40px;
    display: flex;
    align-items: center;
}
.MuiBox-root.productScape{
    display: flex;
    flex-direction: column;
}
.MuiButtonBase-root.selectBtn {
    justify-content: space-between;
}
.GenerateButtonContainer .MuiButtonBase-root{
    width: 100%;
}
.my-masonry-grids{
    display: flex;
    gap: 10px;
}

@media screen and (min-width: 1024px) {
    .GenerateButtonContainer .MuiButtonBase-root{
    width: auto;
}
.MuiBox-root.podcastUpload-Container.productScape>.MuiBox-root>.my-masonry-grids{
min-height: 400px;
}

.MuiBox-root.podcastUpload-Container.productScape>.MuiBox-root>.uploaded-images-grid{
min-height: 400px;
}
}

@media screen and (min-width: 1200px) {
.MuiBox-root.productScape{
flex-direction: row;
}
.productScape .MuiFormControl-root {
    width: 50%;
}

    
}
@media screen and (max-width: 460px) {
.MuiBox-root.productContainer{
 overflow:auto;
 height: calc(100vh - 55px);
}
}`, "",{"version":3,"sources":["webpack://./src/components/ProductScape/ProductScape.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI;IACA,WAAW;AACf;AACA;AACA,iBAAiB;AACjB;;AAEA;AACA,iBAAiB;AACjB;AACA;;AAEA;AACA;AACA,mBAAmB;AACnB;AACA;IACI,UAAU;AACd;;;AAGA;AACA;AACA;CACC,aAAa;CACb,0BAA0B;AAC3B;AACA","sourcesContent":[".MuiTypography-root.productHeading {\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 20px;\n    color: #EBEBF5;\n    padding-left: 3px;\n    padding-top: 0px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n}\n.MuiBox-root.productScape{\n    display: flex;\n    flex-direction: column;\n}\n.MuiButtonBase-root.selectBtn {\n    justify-content: space-between;\n}\n.GenerateButtonContainer .MuiButtonBase-root{\n    width: 100%;\n}\n.my-masonry-grids{\n    display: flex;\n    gap: 10px;\n}\n\n@media screen and (min-width: 1024px) {\n    .GenerateButtonContainer .MuiButtonBase-root{\n    width: auto;\n}\n.MuiBox-root.podcastUpload-Container.productScape>.MuiBox-root>.my-masonry-grids{\nmin-height: 400px;\n}\n\n.MuiBox-root.podcastUpload-Container.productScape>.MuiBox-root>.uploaded-images-grid{\nmin-height: 400px;\n}\n}\n\n@media screen and (min-width: 1200px) {\n.MuiBox-root.productScape{\nflex-direction: row;\n}\n.productScape .MuiFormControl-root {\n    width: 50%;\n}\n\n    \n}\n@media screen and (max-width: 460px) {\n.MuiBox-root.productContainer{\n overflow:auto;\n height: calc(100vh - 55px);\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
